import Methods from "../methods";

const searchLows = (context, payload) => {
  const {type, filters, page, size, sortBy = "registrationDate", direction = "desc"} = payload;
  const url = `api/lows/search?type=${type}&page=${page}&size=${size}&sortBy=${sortBy}&direction=${direction}`;
  return Methods.doPost(context, url, filters, null);
};

const loadLowRequests = (context, payload) => {
  // payload: { idClient, type, statuses, page, size }
  const types = payload.type || ''; // "type" ahora es singular en la lógica del frontend
  const statuses = payload.statuses || '';

  const url = `api/lows/${payload.idClient}?type=${types}&statuses=${statuses}&page=${payload.page}&size=${payload.size}`;
  return Methods.doGet(context, url);
};

const updateLowRequestStatus = (context, payload) => {
  // payload: { id, data: { type, status, observation } }
  const url = `api/lows/${payload.id}`;
  return Methods.doPut(context, url, payload.data);
};

const requestDetailReport = (context, payload) => {
  const url = `api/lows/${payload.id}/report?type=${payload.type}`;
  return Methods.doPost(context, url);
};

const downloadDetailReport = (context, payload) => {
  const url = `api/lows/${payload.id}/report/download?type=${payload.type}`;
  return Methods.doGet2(context, url, { responseType: 'blob' }); // Petición GET que espera un blob
};

const queryLowRequestsByDate = (context, params) => {
  const url = `api/lows/query-by-date?idClient=${params.idClient}&type=${params.type}&dateFrom=${params.dateFrom}&dateTo=${params.dateTo}&status=${params.status}&page=${params.page}&size=${params.size}`;
  return Methods.doGet2(context, url);
};

const requestReportByDate = (context, payload) => {
  return Methods.doPost(context, 'api/lows/report-by-date/request', payload);
};

const downloadReport = (context, reportId) => {
  return Methods.doGet2(context, `api/lows/report-by-date/download/${reportId}`, { responseType: 'blob' });
};

export default {
  searchLows,
  loadLowRequests,
  updateLowRequestStatus,
  requestDetailReport,
  downloadDetailReport,
  queryLowRequestsByDate,
  requestReportByDate,
  downloadReport,
};



// WEBPACK FOOTER //
// ./src/api/modules/LowApi.js